import _ from 'lodash';

/**
 * 树结构选项过滤
 * 只筛选子集，不筛选父集，如果子集为空也不显示父集
 *
 * @param options - 树形选项数组
 * @param optionFilter - 自定义过滤函数，只对叶子节点生效
 * @returns 过滤后的树形数据
 *
 * @example
 * treeOptionsFilter(treeData, (item) => item.name.includes('搜索词'))
 */
export function treeOptionsFilter(options: any[], optionFilter?: (item: any) => boolean) {
  let temOptions = options?.length ? _.cloneDeep([...options]) : [];
  if (optionFilter) {
    // 只筛选子集，不筛选父集，如果子集没有，也不显示父集
    temOptions.forEach((item: any) => {
      const children = item.children;
      if (children) {
        const filteredChildren = children.filter((childItem: any) => optionFilter(childItem));
        item.children = filteredChildren;
      }
    });
    temOptions = _.filter(temOptions, (item: any) => {
      if (!item.children) {
        return true;
      }
      return item.children.length > 0;
    });
  }
  return temOptions;
}
